<template>
  <div class="card-files">
    <div class="attach-container">
      <div class="attach" @click="chooseFiles()">
        <font-awesome-icon icon="paperclip" />
        <span class="ml-1">Прикрепить файл</span>
        <input type="file" class="display-none" ref="fileInput" @change="attachFiles()" />
      </div>
      <div v-for="file in files" :key="file.id" @contextmenu.prevent="copyUrlToClipboard(file)">
        <font-awesome-icon class="copy-to-clipboard" icon="copy" @click="copyUrlToClipboard(file)" />
        <font-awesome-icon class="delete mh-1" icon="times" @click="deleteFile(file)" />
        <a
          :href="file.url"
          class="file-link"
          target="_blank"
          rel="noopener noreferrer"
        >{{file.name}}</a>
      </div>
    </div>
    <div class="upload-container pt-1" v-if="uploadingFiles.length">
      <div class="file-to-upload mr-1" v-for="file in uploadingFiles" :key="file.uploadId">
        <spinner class="spinner mr-1" size="14"></spinner>
        <span class="file-link">{{file.name}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import FileUploader from "@/common/fileUploader";
import FilesHelpers from "@/common/filesHelpers";
import SimpleClipboard from "@/common/simpleClipboard";

export default {
  props: ["card"],
  computed: {
    files() {
      if (!this.card) {
        return [];
      }
      return this.card.files;
    },
    uploadingFiles() {
      if (!this.card) {
        return [];
      }
      return this.card.uploadingFiles;
    }
  },
  data() {
    return {
      filesHelpers: new FilesHelpers()
    };
  },
  methods: {
    copyUrlToClipboard(file) {
      new SimpleClipboard().copyText(encodeURI(file.url));
      this.$snotify.success(`Ссылка на файл ${file.name} скопирована`, {
        timeout: 1000,
        showProgressBar: false
      });
    },
    deleteFile(file) {
      const _this = this;
      this.$modal.show("ConfirmationDialog", {
        message: `Точно удалить файл <b>${file.name}</b>?`,
        yes: () => {
          _this.$store.dispatch("files/delete", file);
        }
      });
    },
    chooseFiles() {
      //hack to choose file
      this.$refs.fileInput.click();
    },
    attachFiles() {
      const files = this.$refs.fileInput.files;

      const fileUploader = new FileUploader(this, this.card);
      fileUploader.uploadFiles(files);
    }
  }
};
</script>
<style lang="postcss">
.card-files {
  .attach-container {
    display: flex;
    flex-wrap: wrap;
    div {
      padding: 0.2em;
      margin-right: 0.5em;
    }
    .delete {
      cursor: pointer;

      &:hover {
        color: var(--color-gray);
      }
    }

    .copy-to-clipboard {
      cursor: pointer;

      &:hover {
        color: var(--color-gray);
      }
    }
    .attach {
      color: var(--color-light);
      cursor: pointer;
      background: var(--color-gray);

      &:hover {
        background: var(--color-dim-gray);
      }
    }
  }

  .file-link {
    text-decoration: none;
    color: var(--color-text-default);
  }

  .upload-container {
    display: flex;
    flex-wrap: wrap;
    .file-to-upload {
      display: grid;
      grid-template-columns: auto auto;
      align-items: center;

      .spinner {
      }
    }
  }
}
</style>


